import React from 'react';
import './ServicesPage.css';
import RouteLink from './RouteLink';

function ServicesPage() {
  return (
    <div className="services-page">
      <header className="services-nav">
        <RouteLink className="services-brand" to="/">Social Games Studio</RouteLink>
        <div className="services-actions">
          <RouteLink className="services-link" to="/">Home</RouteLink>
          <a className="services-cta" href="#studio">Talk to us</a>
        </div>
      </header>

      <main>
        <section className="services-hero">
          <div className="services-hero-copy">
            <p className="services-eyebrow">Custom game design + hosting</p>
            <h1>We design social games and host them so they run smoothly day and night.</h1>
            <p className="services-lead">
              We focus on lively, friend-first play loops. Our hosting keeps matchmaking, player data, and
              live events stable so your community can keep showing up.
            </p>
            <div className="services-hero-actions">
              <a className="cta primary" href="#process">See the process</a>
              <RouteLink className="cta ghost" to="/">Back to home</RouteLink>
            </div>
          </div>
          <div className="services-hero-card">
            <h2>Two focus areas</h2>
            <ul>
              <li><strong>Custom Game Design</strong> — unique mechanics, social hooks, and a look that fits your world.</li>
              <li><strong>Hosting + Ops</strong> — deployment, uptime, analytics, and steady performance.</li>
            </ul>
          </div>
        </section>

        <section className="services-grid">
          <article className="service-block">
            <h3>Custom Game Design</h3>
            <p>
              We start with your audience and build the right core loop. Expect playful interactions,
              thoughtful progression, and social features that feel natural.
            </p>
            <div className="service-tags">
              <span>Game systems</span>
              <span>Social loops</span>
              <span>Art direction</span>
            </div>
          </article>
          <article className="service-block">
            <h3>Hosting + Live Ops</h3>
            <p>
              Reliable hosting, smooth sessions, and real-time tuning. We watch performance, ship updates,
              and keep your community connected.
            </p>
            <div className="service-tags">
              <span>Scalable hosting</span>
              <span>Monitoring</span>
              <span>Events</span>
            </div>
          </article>
          <article className="service-block highlight">
            <h3>Ongoing Partnership</h3>
            <p>
              We are a small studio, so you get direct access. Fast feedback loops, clear updates,
              and a team that cares about the details.
            </p>
            <div className="service-tags">
              <span>Weekly check-ins</span>
              <span>Iterative polish</span>
              <span>Player care</span>
            </div>
          </article>
        </section>

        <section id="process" className="process">
          <div className="process-header">
            <h2>A simple, fun process</h2>
            <p>Four steps. Clear milestones. Plenty of playtesting.</p>
          </div>
          <div className="process-steps">
            <div className="process-step">
              <span className="step-number">01</span>
              <h4>Spark</h4>
              <p>We explore your vision, audience, and favorite social moments.</p>
            </div>
            <div className="process-step">
              <span className="step-number">02</span>
              <h4>Prototype</h4>
              <p>We build quick playable slices and test them with real people.</p>
            </div>
            <div className="process-step">
              <span className="step-number">03</span>
              <h4>Launch Party</h4>
              <p>We polish, deploy, and make sure hosting is rock solid.</p>
            </div>
            <div className="process-step">
              <span className="step-number">04</span>
              <h4>Level Up</h4>
              <p>We ship new events and content to keep players coming back.</p>
            </div>
          </div>
        </section>

        <section id="studio" className="services-cta-panel">
          <div>
            <h2>Ready to build something social?</h2>
            <p>We are a small studio that loves collaboration. Let’s make it fun.</p>
          </div>
          <div className="services-cta-actions">
            <RouteLink className="cta primary" to="/">Visit the home page</RouteLink>
            <a className="cta ghost" href="mailto:hello@socialgames.studio">Start a conversation</a>
          </div>
        </section>
      </main>

      <footer className="services-footer">
        <span>Social Games Studio · Custom game design + hosting</span>
        <span>Built for social play.</span>
      </footer>
    </div>
  );
}

export default ServicesPage;
